import { useCallback, useEffect, useRef } from 'react';
export default function useMealSuggestionJob(scope) {
  const current = useRef(null);
  const cancel = useCallback(() => { current.current?.abort(); current.current = null; }, []);
  useEffect(() => cancel, [scope, cancel]);
  const start = useCallback(() => { cancel(); const next = new AbortController(); current.current = next; return next; }, [cancel]);
  const isCurrent = useCallback(attempt => current.current === attempt && !attempt.signal.aborted, []);
  return { start, cancel, isCurrent };
}
